// WARNING: This file has been auto-generated! Do not manually edit this file!

export const VERSION = "1.7.1";
